export const DEVICE_LOCATION_CONTEXT_COOKIE = 'gp_device_location_context';
export const DEVICE_LOCATION_HINT_STORAGE_KEY = 'gp_device_location_hint';
export const DEVICE_LOCATION_IP_CACHE_STORAGE_KEY = 'gp_device_location_ip_hint';

export type DeviceLocationHint = {
  latitude: number;
  longitude: number;
  accuracy: number | null;
  capturedAt: string;
};

export type DeviceLocationCookiePayload = {
  timeZone?: string | null;
  locationHint?: DeviceLocationHint | null;
  clientLocation?: ResolvedDeviceLocation | null;
};

export type ResolvedDeviceLocation = {
  city: string | null;
  region: string | null;
  country: string | null;
  displayName: string | null;
  source: 'gps' | 'ip';
  precision: 'precise' | 'approximate';
  accuracyMeters: number | null;
  capturedAt: string | null;
};